import { render, staticRenderFns } from "./SettingsBotThemeJson.vue?vue&type=template&id=11da7934&"
import script from "./SettingsBotThemeJson.vue?vue&type=script&lang=js&"
export * from "./SettingsBotThemeJson.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBotThemeJson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports